import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import PlanningVersionUpgradeResponseContainer from './PlanningVersionUpgradeResponse/PlanningVersionUpgradeResponseContainer';


const PlanningVersionUpgradeResponsePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.planningVersionUpgradeResponse.name]: (<PlanningVersionUpgradeResponseContainer relationshipLink={resource?.relationship(fr.relationships.planningVersionUpgradeResponse.name)?.link('related')} />),
  }, null);
};

PlanningVersionUpgradeResponsePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
PlanningVersionUpgradeResponsePicker.defaultProps = {};

export default PlanningVersionUpgradeResponsePicker;
